document.addEventListener("DOMContentLoaded", () => {

    /*====================================================
      CONFIGURADOR
    ====================================================*/

    const roomFinder = document.querySelector(".room-finder");

    if (!roomFinder) return;


    /*====================================================
      ELEMENTOS
    ====================================================*/

    const sizeButtons =
        roomFinder.querySelectorAll(".rf-size");

    const colorDropdown =
        roomFinder.querySelector(".rf-color-dropdown");

    const colorTrigger =
        roomFinder.querySelector("#rf-color-trigger");

    const colorOptionsContainer =
        roomFinder.querySelector("#rf-color-options");

    const colorOptions =
        roomFinder.querySelectorAll(".rf-color-option");

    const selectedSwatch =
        roomFinder.querySelector("#rf-selected-swatch");

    const selectedName =
        roomFinder.querySelector("#rf-selected-name");

    const searchButton =
        roomFinder.querySelector("#rf-search-btn");


    let selectedSize = "";

    let selectedColor = "";


    /*====================================================
      TAMAÑOS
    ====================================================*/

    sizeButtons.forEach(button => {

        button.addEventListener("click", () => {

            sizeButtons.forEach(btn => {

                btn.style.background = "#fff";
                btn.style.color = "#222";
                btn.style.borderColor = "#ddd";

            });


            button.style.background = "#222";
            button.style.color = "#fff";
            button.style.borderColor = "#222";


            selectedSize = button.dataset.filter;

        });

    });


    /*====================================================
      DROPDOWN DE COLORES
    ====================================================*/

    if (
        colorDropdown &&
        colorTrigger &&
        colorOptionsContainer
    ) {


        /*==============================================
          ABRIR / CERRAR
        ==============================================*/

        colorTrigger.addEventListener("click", () => {

            const isOpen =
                colorDropdown.classList.contains("open");


            if (isOpen) {

                closeColorDropdown();

            } else {

                openColorDropdown();

            }

        });


        /*==============================================
          SELECCIONAR COLOR
        ==============================================*/

        colorOptions.forEach(option => {

            option.addEventListener("click", () => {

                selectedColor =
                    option.dataset.filter;


                const colorName =
                    option.dataset.name;


                const swatchColor =
                    option.dataset.swatch;


                /*--------------------------------------
                  Actualizar nombre
                --------------------------------------*/

                if (selectedName) {

                    selectedName.textContent =
                        colorName;

                }


                /*--------------------------------------
                  Actualizar círculo
                --------------------------------------*/

                if (selectedSwatch) {

                    selectedSwatch.style.background =
                        swatchColor;

                    selectedSwatch.classList.add("active");

                }


                /*--------------------------------------
                  Estado de opciones
                --------------------------------------*/

                colorOptions.forEach(item => {

                    item.setAttribute(
                        "aria-selected",
                        "false"
                    );

                });


                option.setAttribute(
                    "aria-selected",
                    "true"
                );


                closeColorDropdown();

            });

        });


        /*==============================================
          CLICK FUERA
        ==============================================*/

        document.addEventListener("click", (event) => {

            if (
                !colorDropdown.contains(event.target)
            ) {

                closeColorDropdown();

            }

        });


        /*==============================================
          TECLADO
        ==============================================*/

        colorTrigger.addEventListener(
            "keydown",
            (event) => {

                if (
                    event.key === "Enter" ||
                    event.key === " "
                ) {

                    event.preventDefault();

                    const isOpen =
                        colorDropdown.classList.contains("open");


                    if (isOpen) {

                        closeColorDropdown();

                    } else {

                        openColorDropdown();

                    }

                }


                if (event.key === "Escape") {

                    closeColorDropdown();

                }

            }
        );

    }


    /*====================================================
      ABRIR DROPDOWN
    ====================================================*/

    function openColorDropdown() {

        if (
            !colorDropdown ||
            !colorTrigger ||
            !colorOptionsContainer
        ) return;


        colorDropdown.classList.add("open");

        colorTrigger.setAttribute(
            "aria-expanded",
            "true"
        );

        colorOptionsContainer.hidden = false;

    }


    /*====================================================
      CERRAR DROPDOWN
    ====================================================*/

    function closeColorDropdown() {

        if (
            !colorDropdown ||
            !colorTrigger ||
            !colorOptionsContainer
        ) return;


        colorDropdown.classList.remove("open");

        colorTrigger.setAttribute(
            "aria-expanded",
            "false"
        );

        colorOptionsContainer.hidden = true;

    }


    /*====================================================
      BOTÓN BUSCAR
    ====================================================*/

    if (searchButton) {

        searchButton.addEventListener("click", (e) => {

            e.preventDefault();


            /*------------------------------------------
              Validar tamaño
            ------------------------------------------*/

            if (!selectedSize) {

                alert(
                    "Selecciona el tamaño de tu sala."
                );

                return;

            }


            /*------------------------------------------
              Validar color
            ------------------------------------------*/

            if (!selectedColor) {

                alert(
                    "Selecciona un color."
                );

                return;

            }


            /*------------------------------------------
              URL BASE
            ------------------------------------------*/

            const baseUrl =
                searchButton.dataset.collection;


            const params =
                new URLSearchParams();


            /*------------------------------------------
              Datos Room Finder
            ------------------------------------------*/

            params.set(
                "rf",
                "1"
            );

            params.set(
                "rf_size",
                selectedSize
            );

            params.set(
                "rf_color",
                selectedColor
            );


            /*------------------------------------------
              Filtros Shopify
            ------------------------------------------*/

            params.set(
                "filter.v.price.gte",
                ""
            );

            params.set(
                "filter.v.price.lte",
                ""
            );


            params.set(
                searchButton.dataset.sizeFilter,
                selectedSize
            );


            params.set(
                searchButton.dataset.colorFilter,
                selectedColor
            );


            /*------------------------------------------
              Orden
            ------------------------------------------*/

            params.set(
                "sort_by",
                "manual"
            );


            params.set(
                "view",
                "grid"
            );


            /*------------------------------------------
              REDIRECCIÓN
            ------------------------------------------*/

            window.location.href =
                `${baseUrl}?${params.toString()}`;

        });

    }

});